/**
 * Phase 3 - flow: ダイアログフロー → appReady
 *
 * checkingDialogs でアンケート表示の要否を判定し、
 * checkingConfirm で確認ポップアップの要否を判定して appReady に到達する。
 * 認証済み・未認証どちらも appReady に到達する（context.isAuthenticated で区別）。
 */
export const phase3FlowConfig = {
  initial: 'checkingDialogs' as const,
  states: {
    checkingDialogs: {
      always: [
        { target: 'showingQuestionnaire' as const, guard: 'needsQuestionnaire' as const },
        { target: 'checkingConfirm' as const },
      ],
    },
    showingQuestionnaire: {
      on: {
        QUESTIONNAIRE_SUBMITTED: 'checkingConfirm' as const,
      },
    },
    checkingConfirm: {
      always: [{ target: 'showingConfirm' as const, guard: 'needsConfirm' as const }, { target: 'appReady' as const }],
    },
    showingConfirm: {
      on: {
        CONFIRM_CLOSED: {
          target: 'appReady' as const,
          actions: 'saveConfirmClosed' as const,
        },
      },
    },
    // ページ固有処理に遷移可能な安定状態
    // 認証済み・未認証どちらもここに到達する（context.isAuthenticated で区別）
    appReady: {},
  },
}
